import React from "react";
import { Handle, Position } from "@xyflow/react";
import { icon } from "../../../../config";
import "./StarterNode.scss";

const StarterNode = ({ data }) => {
  const handleClick = (event) => {
    if (data?.onClick) {
      data.onClick(event);
    }
  };

  return (
    <div className='starter-node-component' onClick={handleClick}>
      <div className='starter-badge'>
        <div className='starter-icon-wrapper'>
          <span className='starter-icon'>{icon.ADD_TASK_APP}</span>
        </div>
        <span className='starter-text'>Task Created</span>
      </div>
      <Handle type='source' position={Position.Bottom} id='bottom' />
    </div>
  );
};

export default StarterNode;
